import { Skeleton } from '@/components/atoms/Skeleton';
import PaginaVendaDesktopFallback from '@/components/templates/PaginaVendaDesktopTemplate/fallback';
import { theme } from '@/styles/theme';

export default function ServicoAssinaturaPaginaDesktopFallback() {
  return (
    <PaginaVendaDesktopFallback
      $fallbackConteudoCheckout={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing[5],
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme.spacing[4],
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: theme.spacing[4],
              }}
            >
              <Skeleton style={{ height: 40, width: 40 }} />
              <Skeleton style={{ height: 20, width: 150 }} />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: theme.spacing[4],
                overflowX: 'auto',
              }}
            >
              <Skeleton
                style={{
                  width: 228,
                  height: 205,
                  flexShrink: 0,
                }}
              />
              <Skeleton
                style={{
                  width: 120,
                  height: 205,
                  flexShrink: 0,
                }}
              />
              <Skeleton
                style={{
                  width: 120,
                  height: 205,
                  flexShrink: 0,
                }}
              />
            </div>
          </div>
        </div>
      }
      $fallbackConteudoDescritivo={
        <div>
          <Skeleton style={{ height: 200 }} />
        </div>
      }
    />
  );
}
